import { AnalyticsContext, OnboardingPath } from '@/utils/analytics/types';
import { WorkspaceT } from '@/pages/workgroup/type';

type AnalyticsContextOverrides = {
  workgroup_id?: string;
  workspace_id?: string;
  database_id?: string;
  graph_id?: string;
  onboarding_path?: OnboardingPath;
};

export function buildAnalyticsContext(
  overrides: AnalyticsContextOverrides = {},
  sources?: {
    userId?: string;
    organizationId?: string;
    workspace?: WorkspaceT | null;
    graphId?: string;
    onboardingPath?: OnboardingPath;
  }
): AnalyticsContext {
  const workspace = sources?.workspace;

  return {
    user_id: sources?.userId,
    organization_id: sources?.organizationId,
    workgroup_id: overrides.workgroup_id ?? workspace?.workgroup_id,
    workspace_id: overrides.workspace_id ?? workspace?.workspace_id,
    database_id: overrides.database_id ?? workspace?.database_id,
    graph_id: overrides.graph_id ?? sources?.graphId,
    onboarding_path: overrides.onboarding_path ?? sources?.onboardingPath,
  };
}
